import PrivatePlacement from '../privatePlacement';
import Reit from '../reit';

const ioFactory = ({ ioDetailType }) => (
  ioDetailType === 'REIT' ? Reit : PrivatePlacement
);

export default ioFactory;
